import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import router from './config/route'
import { Provider } from 'react-redux';

import './index.css'
import '../src/utils/fixed'
import '../src/locales/i18n'
import store from "./store/store";



const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  // <React.StrictMode>
    <Provider store={store}>
    <RouterProvider router={router} />
    </Provider>
  // </React.StrictMode>
)

